import React from 'react';
import { Row, Col, Tabs } from 'antd';
import { Settings, BadgePercent, ShieldCheck } from 'lucide-react';
import { useI18n } from 'hooks/useI18n';

import ServiceList from 'pages/services/service-list';
import MembershipList from 'pages/memberships/membership-list';
import RoleManagement from 'pages/role-management';

const Master = () => {
	const { t } = useI18n();
	
	const MASTER_TAB = [
		{
			tabName: t('master.tabs.services'),
			icon: <Settings size={16} style={{ marginRight: 6 }} />,
			component: ServiceList,
		},
		{
			tabName: t('master.tabs.memberships'),
			icon: <BadgePercent size={16} style={{ marginRight: 6 }} />,
			component: MembershipList,
		},
		{
			tabName: t('master.tabs.role_management'),
			icon: <ShieldCheck size={16} style={{ marginRight: 6 }} />,
			component: RoleManagement,
		},
	];
	const tabItems = MASTER_TAB.map(({ tabName, icon, component }, index) => {
		const Component = component;
		return {
			label: (
				<span style={{ display: 'flex', alignItems: 'center' }}>
					{icon}
					{tabName}
				</span>
			),
			key: String(index),
			children: <Component />,
		};
	});

	return (
		<Row className="personal-training-tab-container">
			<Col xl={24} className="container">
				<Tabs defaultActiveKey="0" destroyInactiveTabPane items={tabItems} />
			</Col>
		</Row>
	);
};

export default Master;
